/**
 * UTM helper for outbound-to-calculator CTAs.
 *
 * Why this exists: GA4 records the referrer-page automatically for in-session
 * navigation, but it doesn't aggregate which guide/rail/promo *originated*
 * a calculator open. UTMs solve that — they get captured by GA4 as event
 * parameters on the destination page_view and let us slice
 * "calculator opens by source surface" in standard GA4 explorations.
 *
 * Scope: ONLY for links that move users from CONTENT/PROMO to a CONVERSION
 * surface (a calculator). Do NOT use this for general internal navigation
 * (state-landing chips, sibling guides, etc.) — UTMs on internal nav
 * overwrite the natural traffic source in GA4 and break attribution.
 */
const isSafePath = (p) => typeof p === "string" && p.startsWith("/");

const safeEncode = (v) => {
  if (v === undefined || v === null) return "";
  // GA4 utm_campaign can't contain `&`, `?`, or `#`. Slugs already comply
  // with that constraint (a-z, 0-9, hyphen), but be defensive anyway.
  return encodeURIComponent(String(v)).replace(/[?#&]/g, "");
};

export function withUtm(path, { source, medium, campaign }) {
  if (!isSafePath(path)) return path;
  const params = [];
  if (source) params.push(`utm_source=${safeEncode(source)}`);
  if (medium) params.push(`utm_medium=${safeEncode(medium)}`);
  if (campaign) params.push(`utm_campaign=${safeEncode(campaign)}`);
  if (params.length === 0) return path;
  const sep = path.includes("?") ? "&" : "?";
  return `${path}${sep}${params.join("&")}`;
}
